import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import WarningIcon from '@mui/icons-material/Warning';
import { getAxiosErrorMessage } from '../../../common/utils/helpers';
import OvBackButton from '../atoms/OvBackButton';
import OvCompactButton from '../atoms/OvCompactButton';
import OvRecordDetailsCanvas from '../atoms/OvRecordDetailsCanvas';
import OvListStateMessage from './OvListStateMessage';

interface OvRecordDetailsErrorStateProps {
  title: string;
  error: unknown;
  onRetry: () => void;
  backLabel?: string;
  backPath?: string;
}

const OvRecordDetailsErrorState: FC<OvRecordDetailsErrorStateProps> = ({
  title,
  error,
  onRetry,
  backLabel,
  backPath,
}) => {
  const { t } = useTranslation();

  return (
    <OvRecordDetailsCanvas>
      <OvListStateMessage
        isAlert
        icon={<WarningIcon />}
        title={title}
        description={getAxiosErrorMessage(error)}
      >
        <Actions>
          {backLabel && (
            <OvBackButton label={backLabel} fallbackPath={backPath} />
          )}
          <OvCompactButton onClick={onRetry}>
            {t('common.actions.retry')}
          </OvCompactButton>
        </Actions>
      </OvListStateMessage>
    </OvRecordDetailsCanvas>
  );
};

export default OvRecordDetailsErrorState;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;
